import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {tabKeys} from "types/enums";
import {EXAMINATION_ACTION_TYPE} from "types/enums/examination";

type State = {
  actionType: EXAMINATION_ACTION_TYPE;
  idReceipt: number | string;
  dataPassing: any;
  idPKNT: string;
  currentIdPKNT: string;
  examinationId: string;
  buttonHeaderExam: any[];
  dataPhieu: any;
  dataChanDoan: any;
  objectChanDoan: any;
  ref: any;
  form: any;
  activeExamTab: any;
  requiredTaiKham: boolean;
  loadingCompleteKCB: boolean;
};

const initialState: State = {
  actionType: EXAMINATION_ACTION_TYPE.NORMAL,
  dataPassing: null,
  idPKNT: null,
  examinationId: null,
  buttonHeaderExam: [],
  dataPhieu: null,
  dataChanDoan: null,
  objectChanDoan: null,
  ref: null,
  form: null,
  idReceipt: null,
  activeExamTab: tabKeys.EXAMINATION_INFO_DETAIL.EXAM,
  requiredTaiKham: false,
  loadingCompleteKCB: false,
  currentIdPKNT:null
};

export const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setExaminationId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, examinationId: action.payload};
    },
    setIdPKNT: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idPKNT: action.payload};
    },
    setIdReceiptExamOut: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idReceipt: action.payload};
    },
    setActionType: (state = initialState, action: PayloadAction<any>) => {
      return {...state, actionType: action.payload};
    },
    setDataPassing: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataPassing: action.payload};
    },
    setButtonHeaderExam: (state = initialState, action: PayloadAction<any>) => {
      return {...state, buttonHeaderExam: action.payload};
    },
    setAction: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        actionType: action.payload.actionType,
        dataPassing: action.payload.dataPassing,
      };
    },
    setDataPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataPhieu: action.payload};
    },
    setDataChanDoan: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataChanDoan: action.payload};
    },
    setObjectChanDoan: (state = initialState, action: PayloadAction<any>) => {
      return {...state, objectChanDoan: action.payload};
    },
    setRef: (state = initialState, action: PayloadAction<any>) => {
      return {...state, ref: action.payload};
    },
    setForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, form: action.payload};
    },
    setActiveExamTab: (state = initialState, action: PayloadAction<any>) => {
      return {...state, activeExamTab: action.payload};
    },
    setRequiredTaiKham: (state = initialState, action: PayloadAction<any>) => {
      return {...state, requiredTaiKham: action.payload};
    },
    setLoadingCompleteKCB: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, setLoadingCompleteKCB: action.payload};
    },
    setCurrentIdPKNT: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, currentIdPKNT: action.payload};
    },
  },
});

export const {
  setActionType,
  setDataPassing,
  setAction,
  setExaminationId,
  setButtonHeaderExam,
  setDataPhieu,
  setDataChanDoan,
  setObjectChanDoan,
  setIdPKNT,
  setRef,
  setForm,
  setIdReceiptExamOut,
  setActiveExamTab,
  setRequiredTaiKham,
  setLoadingCompleteKCB,
  setCurrentIdPKNT,
} = commonSlice.actions;

export default commonSlice.reducer;
